/**
 * ARK footer — scroll-driven marquee scale + optional scroll-to-top button.
 */
(function () {
  'use strict';

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function init() {
    var root = document.querySelector('[data-ark-footer-root]');
    if (!root) return;

    bindScrollTopButton(root);

    var marquee = root.querySelector('[data-ark-footer-marquee]');
    if (!marquee) return;

    var minScaleRaw = Number.parseFloat(root.getAttribute('data-scale-min'));
    var maxScaleRaw = Number.parseFloat(root.getAttribute('data-scale-max'));
    var minScale =
      typeof minScaleRaw === 'number' && !Number.isNaN(minScaleRaw) && minScaleRaw > 0 ? minScaleRaw : 0.28;
    var maxScale =
      typeof maxScaleRaw === 'number' && !Number.isNaN(maxScaleRaw) && maxScaleRaw > minScale
        ? maxScaleRaw
        : Math.max(minScale + 0.01, 1);

    function setMarqueeScale(value) {
      marquee.style.setProperty('--ark-footer-marquee-scale', String(value.toFixed(4)));
    }

    /**
     * scroll-driven scale capped so intrinsic text width × scale stays inside marquee track width
     * (layout ignores transform; visual overflow was widening the document in some browsers).
     */
    function applyMarqueeScaleWithFit(desiredScale) {
      var wrap = marquee.parentElement;
      var cw = wrap && typeof wrap.clientWidth === 'number' ? wrap.clientWidth : 0;
      var tw = typeof marquee.scrollWidth === 'number' ? marquee.scrollWidth : 0;
      var insetPx = cw > 0 ? 8 : 0;
      var safeW = cw > insetPx ? cw - insetPx * 2 : cw;
      var fitCap = safeW > 0 && tw > 0 ? safeW / tw : Number.POSITIVE_INFINITY;
      var s = Math.min(desiredScale, fitCap);
      setMarqueeScale(Math.max(s, 0.0001));
    }

    var raf = null;
    function tick() {
      raf = null;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var entry = vh - rect.top;
      var range = rect.height + vh * 0.18;
      var t = clamp(entry / range, 0, 1);
      t = 1 - Math.pow(1 - t, 1.58);
      var desired = minScale + t * (maxScale - minScale);
      applyMarqueeScaleWithFit(desired);
    }

    function scheduleTick() {
      if (raf != null) return;
      raf = window.requestAnimationFrame(tick);
    }

    function onScrollSchedule() {
      scheduleTick();
    }

    var reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scrollOpts = { passive: true };

    function onResizeMarquee() {
      if (reducedMq.matches) {
        applyMarqueeScaleWithFit(maxScale);
      } else {
        scheduleTick();
      }
    }

    function onReducedMqChange(ev) {
      if (ev.matches) {
        window.removeEventListener('scroll', onScrollSchedule, scrollOpts);
        applyMarqueeScaleWithFit(maxScale);
      } else {
        window.addEventListener('scroll', onScrollSchedule, scrollOpts);
        scheduleTick();
      }
    }

    window.addEventListener('resize', onResizeMarquee);
    if (typeof ResizeObserver !== 'undefined') {
      var wrapObserve = marquee.parentElement;
      if (wrapObserve) new ResizeObserver(onResizeMarquee).observe(wrapObserve);
    }

    try {
      if (document.fonts && typeof document.fonts.ready !== 'undefined' && document.fonts.ready) {
        document.fonts.ready.then(onResizeMarquee);
      }
    } catch (_e0) {}

    if (reducedMq.matches) {
      applyMarqueeScaleWithFit(maxScale);
    } else {
      window.addEventListener('scroll', onScrollSchedule, scrollOpts);
      scheduleTick();
    }

    try {
      reducedMq.addEventListener('change', onReducedMqChange);
    } catch (_e1) {
      reducedMq.addListener(onReducedMqChange);
    }
  }

  function bindScrollTopButton(root) {
    var topBtn = root.querySelector('[data-ark-scroll-top]');
    if (!topBtn) return;

    var showAfterAttr = parseInt(topBtn.getAttribute('data-show-after'), 10);
    var showAfter = Number.isFinite(showAfterAttr) ? showAfterAttr : 400;

    function getScrollProgress() {
      var doc = document.documentElement;
      var body = document.body;
      var scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset || 0;
      var vh = window.innerHeight || doc.clientHeight || 1;
      var scrollHeight = Math.max(
        doc.scrollHeight,
        body ? body.scrollHeight : 0,
        doc.offsetHeight,
        body ? body.offsetHeight : 0
      );
      var total = scrollHeight - vh;
      var denom = total > 0 ? total : 1;
      return clamp(scrollY / denom, 0, 1);
    }

    function updateScrollProgress() {
      var p = getScrollProgress();
      topBtn.style.setProperty('--ark-scroll-progress', String(p));
    }

    function updateVisibility() {
      var y = window.scrollY !== undefined ? window.scrollY : window.pageYOffset || 0;
      var shouldShow = y > showAfter;
      topBtn.hidden = !shouldShow;
      topBtn.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function onScrollOrResize() {
      updateScrollProgress();
      updateVisibility();
    }

    updateScrollProgress();
    updateVisibility();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('orientationchange', onScrollOrResize);

    topBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        window.scrollTo({
          top: 0,
          behavior: prefersReduce ? 'auto' : 'smooth',
        });
      } catch (_e2) {
        window.scrollTo(0, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
